module.exports = __webpack_public_path__ + "img/oval.9269cd47.png";